import { loadScript } from './lazylib.js';

export const gridPrint = {
  _ensurePrintButtonStyles: function () {
    if (document.getElementById('ag-print-btn-style')) return;
    const style = document.createElement('style');
    style.id = 'ag-print-btn-style';
    style.textContent = `
      .ag-print-controls { position: absolute; top: 6px; right: 40px; display: flex; gap: 6px; z-index: 5; }
      .ag-print-controls button { background: transparent; color: #ef4444; border: none; border-radius: 4px; width: 26px; height: 26px; padding: 0; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; }
      .ag-print-controls button:hover { background: #f3f4f6; }
      .ag-print-controls button.alt { color: #6b7280; }
      .ag-print-controls i { font-size: 18px; line-height: 1; }
      [data-disable-print="true"] .ag-print-controls,
      [data-disable-print="true"] .ag-print-inline-btn[data-role="print"],
      [data-disable-print="true"] .ag-print-inline-btn[data-role="print-exit"] { display: none !important; }
      /* inline toolbar variant */
      .ag-print-inline-btn { background: #fff; color: #ef4444; border: 1px solid #e5e7eb; width: 28px; height: 28px; border-radius: 9999px; display: inline-flex; align-items: center; justify-content: center; padding: 0; margin-left: 6px; }
      .ag-print-inline-btn:hover { background: #f9fafb; }
      .ag-print-inline-btn.alt { color: #6b7280; }
      /* hide JS-injected inline PDF icon by default (using server-rendered toolbar button instead) */
      .ag-print-inline-btn[data-role='print'] { display: none !important; }
    `;
    document.head.appendChild(style);
  },
  _injectPrintButtons: function (el) {
    try {
      if (el && el.dataset && el.dataset.disablePrint === 'true') {
        el.querySelectorAll('.ag-print-controls, .ag-print-inline-btn[data-role="print"], .ag-print-inline-btn[data-role="print-exit"]').forEach((node) => node.remove());
        return;
      }
      this._ensurePrintButtonStyles();
      try {
        const cs = window.getComputedStyle(el);
        if (cs && (cs.position === 'static' || !cs.position)) {
          el.style.position = 'relative';
        }
      } catch (_e) {}

      if (el.querySelector('.ag-print-controls') || el.querySelector('.ag-print-inline-btn[data-role="print"]')) return;

      const btnPrint = document.createElement('button');

      const btnNormal = document.createElement('button');
      btnNormal.className = 'alt';
      btnNormal.setAttribute('aria-label', 'Exit print layout');
      btnNormal.setAttribute('title', 'Exit print layout');
      btnNormal.style.display = 'none';
      btnNormal.innerHTML = '<i class="bi bi-x-lg" aria-hidden="true"></i>';

      btnPrint.addEventListener('click', () => {
        try { window.ag.setPrintLayout(el); } catch (_e) {}
        btnPrint.style.display = 'none';
        btnNormal.style.display = 'inline-flex';
      });

      btnNormal.addEventListener('click', () => {
        try { window.ag.resetPrintLayout(el); } catch (_e) {}
        btnNormal.style.display = 'none';
        btnPrint.style.display = 'inline-flex';
      });

      const downloadIcon = el.querySelector('button i.bi-download, button i.bi-cloud-download, button i.bi-file-earmark-arrow-down, button i.bi-cloud-arrow-down');
      const gridIcon = el.querySelector('button i.bi-gear, button i.bi-gear-fill, button i.bi-sliders, button i.bi-sliders2');
      const anchorBtn = (downloadIcon && downloadIcon.closest('button')) || (gridIcon && gridIcon.closest('button'));
      const toolbar = anchorBtn ? anchorBtn.parentElement : null;

      if (toolbar) {
        btnPrint.className = 'ag-print-inline-btn';
        btnPrint.dataset.role = 'print';
        btnNormal.className = 'ag-print-inline-btn alt';
        btnNormal.dataset.role = 'print-exit';
        toolbar.insertBefore(btnPrint, anchorBtn.nextSibling);
        toolbar.insertBefore(btnNormal, btnPrint.nextSibling);
      } else {
        const ctr = document.createElement('div');
        ctr.className = 'ag-print-controls';
        ctr.appendChild(btnPrint);
        ctr.appendChild(btnNormal);
        el.appendChild(ctr);
      }
    } catch (_e) {}
  },

  // ----- Print helpers (AG Grid print layout) ---------------------------------
  _resolveGridElement: function (elOrId) {
    if (!elOrId) return null;
    if (elOrId instanceof HTMLElement) return elOrId;
    let el = document.querySelector(`[data-ag-id='${elOrId}']`) || document.getElementById(elOrId);
    return el || null;
  },

  _relaxAncestorsForPrint: function (el) {
    const changed = [];
    let node = el;
    let hops = 0;
    while (node && node !== document.body && hops < 20) {
      const style = node.style || {};
      const snapshot = {
        node,
        height: style.height,
        maxHeight: style.maxHeight,
        overflow: style.overflow,
        overflowY: style.overflowY,
        overflowX: style.overflowX,
      };
      changed.push(snapshot);
      try {
        style.height = 'auto';
        style.maxHeight = 'none';
        style.overflow = 'visible';
        style.overflowY = 'visible';
        style.overflowX = 'visible';
      } catch (_e) {}
      node = node.parentElement;
      hops += 1;
    }
    el.__printAncestors = changed;
  },

  _restoreAncestorsAfterPrint: function (el) {
    const list = el.__printAncestors || [];
    for (const s of list) {
      try {
        s.node.style.height = s.height;
        s.node.style.maxHeight = s.maxHeight;
        s.node.style.overflow = s.overflow;
        s.node.style.overflowY = s.overflowY;
        s.node.style.overflowX = s.overflowX;
      } catch (_e) {}
    }
    delete el.__printAncestors;
  },

  _hideNonGridSiblings: function (el) {
    const hidden = [];
    let node = el;
    let hops = 0;
    while (node && node !== document.body && hops < 20) {
      const parent = node.parentElement;
      if (!parent) break;
      const children = Array.from(parent.children || []);
      for (const child of children) {
        if (child === node) continue;
        hidden.push({ node: child, display: child.style.display });
        try { child.style.display = 'none'; } catch (_e) {}
      }
      node = parent;
      hops += 1;
    }
    el.__printHiddenSiblings = hidden;
  },

  _restoreHiddenSiblings: function (el) {
    const list = el.__printHiddenSiblings || [];
    for (const item of list) {
      try { item.node.style.display = item.display; } catch (_e) {}
    }
    delete el.__printHiddenSiblings;
  },

  _showPrintLoading: function (el) {
    const button = document.getElementById(`printPdfButton-${el.dataset.agId}`);
    if (button) {
      el.__printButtonState = { button, disabled: button.disabled };
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }
    const template = document.getElementById(`grid-print-loading-${el.dataset.agId}`);
    el.appendChild(template.content.cloneNode(true));
  },
  _hidePrintLoading: function (el) {
    el.querySelector('.ag-print-loading')?.remove();
    const state = el.__printButtonState;
    if (!state) return;
    state.button.disabled = state.disabled;
    state.button.removeAttribute('aria-busy');
    delete el.__printButtonState;
  },

  _printPreparedGrid: async function (el, restoreLayout) {
    const frame = document.createElement('iframe');
    frame.className = 'ag-print-frame';
    frame.title = 'Grid print preview';
    frame.setAttribute('aria-hidden', 'true');
    const cleanup = () => {
      frame.remove();
      this._hidePrintLoading(el);
      delete el.__printPending;
    };
    try {
      const assets = [];
      try {
        document.body.appendChild(frame);
        const doc = frame.contentDocument;
        // Quirks mode leaves a header-only first sheet in Chromium's native print flow.
        doc.open();
        doc.write('<!doctype html>');
        doc.close();
        const base = doc.createElement('base');
        base.href = document.baseURI;
        doc.head.appendChild(base);
        doc.title = document.title;
        doc.documentElement.dataset.theme = document.documentElement.dataset.theme || 'light';
        doc.body.className = document.body.className;
        for (const source of document.querySelectorAll('style, link[rel="stylesheet"]')) {
          const style = source.cloneNode(true);
          if (style.tagName === 'LINK') {
            assets.push(new Promise((resolve, reject) => {
              style.onload = resolve;
              style.onerror = () => reject(new Error('Could not load print styles'));
            }));
          }
          doc.head.appendChild(style);
        }
        const content = el.cloneNode(true);
        content.querySelectorAll('.ag-print-loading, .ag-root-wrapper').forEach(node => node.remove());
        doc.body.appendChild(content);
        const footer = document.getElementById(el.__printFooterId);
        if (footer) doc.body.appendChild(footer.cloneNode(true));
      } finally {
        // Restore the live page in the same task, before the browser can paint it.
        restoreLayout();
      }
      await Promise.all(assets);
      await frame.contentDocument.fonts.ready;
      await Promise.all(Array.from(frame.contentDocument.images, image => {
        if (image.complete) return Promise.resolve();
        // A missing optional logo must not prevent printing the report.
        return new Promise(resolve => { image.onload = resolve; image.onerror = resolve; });
      }));
      this._hidePrintLoading(el);
      frame.contentWindow.addEventListener('afterprint', cleanup, { once: true });
      frame.contentWindow.print();
    } catch (error) {
      cleanup();
      throw error;
    }
  },

  // ----- Column width constraints (print-only) ---------------------------------
  _parsePrintMaxWidths: function (el) {
    try {
      const raw = el?.dataset?.printMaxwidths || el?.getAttribute?.('data-print-maxwidths');
      if (!raw) return {};
      let map = {};
      try {
        const obj = JSON.parse(raw);
        if (obj && typeof obj === 'object') return obj;
      } catch (_e) {}
      // fallback: csv like "colA:240,colB:180"
      const parts = String(raw).split(',');
      for (const p of parts) {
        const [k, v] = p.split(':');
        if (!k || !v) continue;
        const key = k.trim();
        const val = parseInt(String(v).trim(), 10);
        if (key && Number.isFinite(val)) map[key] = val;
      }
      return map;
    } catch (_e) { return {}; }
  },

  _applyPrintMaxWidths: function (el) {
    try {
      const gridId = el?.dataset?.agId;
      if (!gridId) return;
      // HTML print table already uses width:100% table-layout:fixed — no zoom needed
      if (el.__printTable) return;
      const api = window[`aggridApi:${gridId}`];
      const PRINT_PAGE_WIDTH = 1100;

      let totalWidth = 0;
      try {
        const rw = el.querySelector('.ag-root-wrapper');
        if (rw) totalWidth = Math.max(rw.scrollWidth || 0, rw.offsetWidth || 0);
      } catch (_e) {}
      
      if (!totalWidth) {
        try {
          const cols = (typeof api.getAllDisplayedColumns === 'function')
            ? api.getAllDisplayedColumns() : [];
          totalWidth = cols.reduce((sum, c) => {
            try { return sum + (c.getActualWidth ? c.getActualWidth() : 100); }
            catch (_e) { return sum + 100; }
          }, 0);
        } catch (_e) {}
      }

      if (totalWidth <= PRINT_PAGE_WIDTH || totalWidth === 0) return;

     
      const zoom = PRINT_PAGE_WIDTH / totalWidth;
      // Apply zoom to print table if it exists, otherwise to grid element
      const target = el.__printTable || el;
      if (!target.__printScaleOrig) {
        target.__printScaleOrig = { zoom: target.style.zoom || '', width: target.style.width || '' };
      }
      target.style.zoom = zoom.toFixed(4);
      target.style.setProperty('width', totalWidth + 'px', 'important');
    } catch (_e) {}
  },

  _restorePrintMaxWidths: function (el) {
    try {
      // Restore zoom from print table or grid element
      const target = (el.__printTable && el.__printTable.__printScaleOrig) ? el.__printTable : el;
      if (target.__printScaleOrig) {
        target.style.zoom = target.__printScaleOrig.zoom;
        target.style.removeProperty('width');
        if (target.__printScaleOrig.width) {
          target.style.width = target.__printScaleOrig.width;
        }
        delete target.__printScaleOrig;
      }
    } catch (_e) {}
  },

  // Compute and set uniform row heights based on wrapped cell contents (print only)
  _fixRowHeightsForPrint: function (el) {
    try {
      if (!el) return;
      const centerContainer = el.querySelector('.ag-center-cols-container');
      const leftContainer = el.querySelector('.ag-pinned-left-cols-container');
      const rightContainer = el.querySelector('.ag-pinned-right-cols-container');
      if (!centerContainer) return;
      const centerRows = Array.from(centerContainer.querySelectorAll('.ag-row'));
      const byAttr = (row, attr) => row && row.getAttribute && row.getAttribute(attr);
      const findSiblingRow = (container, centerRow) => {
        if (!container || !centerRow) return null;
        const attrs = ['row-index', 'row-id', 'aria-rowindex'];
        for (const a of attrs) {
          const val = byAttr(centerRow, a);
          if (val != null) {
            const m = container.querySelector(`.ag-row[${a}='${val}']`);
            if (m) return m;
          }
        }
        const idx = centerRows.indexOf(centerRow);
        return (idx >= 0) ? (container.querySelectorAll('.ag-row')[idx] || null) : null;
      };
      const measureRow = (row) => {
        let maxContentH = 0;
        let maxPad = 0;
        const cells = Array.from(row.querySelectorAll('.ag-cell'));
        for (const cell of cells) {
          const content = cell.querySelector('.ag-cell-value, .ag-group-value') || cell;
          const prev = {
            height: content.style.height,
            overflow: content.style.overflow,
            whiteSpace: content.style.whiteSpace,
            display: content.style.display,
            maxHeight: content.style.maxHeight,
          };
          try {
            content.style.height = 'auto';
            content.style.overflow = 'visible';
            content.style.whiteSpace = 'normal';
            content.style.display = 'block';
            content.style.maxHeight = 'none';
            const h = Math.max(content.scrollHeight || 0, content.getBoundingClientRect().height || 0);
            if (h > maxContentH) maxContentH = h;
          } catch (_e) {}
          content.style.height = prev.height;
          content.style.overflow = prev.overflow;
          content.style.whiteSpace = prev.whiteSpace;
          content.style.display = prev.display;
          content.style.maxHeight = prev.maxHeight;

          try {
            const cs = window.getComputedStyle(cell);
            const pad = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0) +
                        (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
            if (pad > maxPad) maxPad = pad;
          } catch (_e) {}
        }
        // dynamic margin: tighter for single-line rows, slight extra for multi-line
        const baseMargin = 7;
        // measure line-height baseline for this row
        let maxLine = 0;
        try {
          const sample = row.querySelectorAll('.ag-cell');
          sample.forEach(cell => {
            try { const lh = parseFloat(window.getComputedStyle(cell).lineHeight) || 0; if (lh > maxLine) maxLine = lh; } catch (_e) {}
          });
        } catch (_e) {}
        const unit = maxLine > 0 ? maxLine : 16;
        const contentRaw = maxContentH + maxPad;
        const lines = Math.ceil(contentRaw / unit) || 1;
        const extra = lines > 1 ? 2 : 0; // bump for multi-line to avoid clipping
        const target = lines * unit + baseMargin + extra;
        return Math.max(26, Math.ceil(target));
      };
      const rowEntries = [];
      let uniformH = 32;
      for (const cRow of centerRows) {
        const lRow = findSiblingRow(leftContainer, cRow);
        const rRow = findSiblingRow(rightContainer, cRow);
        const allRows = [cRow, lRow, rRow].filter(Boolean);
        const heights = allRows.map(measureRow);
        const targetH = Math.max.apply(null, heights.length ? heights : [32]);
        if (targetH > uniformH) uniformH = targetH;
        rowEntries.push({ rows: allRows, targetH });
      }

      for (const entry of rowEntries) {
        const h = uniformH;
        for (const row of entry.rows) {
          try {
            row.style.setProperty('height', `${h}px`, 'important');
            row.style.setProperty('min-height', `${h}px`, 'important');
            row.style.setProperty('max-height', `${h}px`, 'important');
            const cells = row.querySelectorAll('.ag-cell, .ag-cell-wrapper, .ag-cell-value, .ag-group-value');
            cells.forEach(cell => {
              try {
                cell.style.setProperty('height', `${h}px`, 'important');
                cell.style.setProperty('max-height', `${h}px`, 'important');
                cell.style.setProperty('overflow', 'hidden', 'important');
              } catch (_e) {}
            });
          } catch (_e) {}
        }
      }
    } catch (_e) {}
  },

  // Displayed columns ordered pinned-left, center, pinned-right, without the
  // selection checkbox column.
  _getPrintColumns: function (api) {
    const allCols = (typeof api.getAllDisplayedColumns === 'function')
      ? api.getAllDisplayedColumns() : [];
    return allCols
      .filter(c => {
        const id = c.getColId ? c.getColId() : '';
        const def = c.getColDef ? c.getColDef() : {};
        if (!id) return false;
        if (id.indexOf('ag-Grid-SelectionColumn') !== -1) return false;
        if (!def.field && (def.headerCheckboxSelection || def.checkboxSelection)) return false;
        return true;
      })
      .sort((a, b) => {
        const order = { left: 0, null: 1, right: 2 };
        const pa = a.getPinned ? a.getPinned() : null;
        const pb = b.getPinned ? b.getPinned() : null;
        return (order[pa] || 1) - (order[pb] || 1);
      });
  },

  // Column widths as a percentage of the printed table width.
  _printColumnWidths: function (cols) {
    const widths = cols.map(c => (c.getActualWidth ? c.getActualWidth() : 100));
    const totalWidth = widths.reduce((sum, w) => sum + w, 0);
    return widths.map(w => ((w / totalWidth) * 100).toFixed(2));
  },

  // ERP reports right-align numbers; AG Grid marks such columns in the colDef.
  _printColumnAlign: function (col) {
    const def = col.getColDef ? col.getColDef() : {};
    const types = Array.isArray(def.type) ? def.type : (def.type ? [def.type] : []);
    const cellClass = typeof def.cellClass === 'string' ? def.cellClass : '';
    const numeric = def.cellDataType === 'number'
      || types.includes('numericColumn')
      || types.includes('rightAligned')
      || cellClass.includes('ag-right-aligned-cell');
    return numeric ? 'right' : 'left';
  },

  _printHeaderText: function (el, col) {
    const colId = col.getColId ? col.getColId() : '';
    // Try reading from DOM first (may have custom header renderer)
    const headerCell = el.querySelector(`.ag-header-cell[col-id="${colId}"] .ag-header-cell-text`);
    if (headerCell) return headerCell.textContent || '';
    const def = col.getColDef ? col.getColDef() : {};
    return def.headerName || colId;
  },

  _groupRowLabel: function (rowNode) {
    const groupKey = rowNode.key == null ? '' : String(rowNode.key);
    const childCount = rowNode.allChildrenCount || rowNode.childrenAfterFilter?.length || 0;
    return `${groupKey}${childCount ? ` (${childCount})` : ''}`;
  },

  // Build a proper HTML <table> from AG Grid's rendered print DOM.
  // Solves: (1) header repetition on every printed page via <thead>,
  //         (2) natural text wrapping in table cells (no overflow:hidden clipping).
  _buildPrintTable: function (el) {
    try {
      if (!el) return;
      const gridId = el.dataset.agId;
      const api = window[`aggridApi:${gridId}`];
      if (!api) return;

      // Inject CSS once
      if (!document.getElementById('ag-print-table-style')) {
        const s = document.createElement('style');
        s.id = 'ag-print-table-style';
        s.textContent = `
          .ag-print-table { width: 100%; border-collapse: collapse; border: 3px solid #888; }
          .ag-print-table thead { display: table-header-group; }
          .ag-print-table th {
            font-size: 16px; font-weight: 700; border: 1px solid #cbd5e1;
            padding: 6px 8px; white-space: normal; word-break: normal;
            background: #fff; color: #000; vertical-align: middle; line-height: 1.3;
          }
          .ag-print-table td {
            border: 1px solid #cbd5e1; padding: 6px 8px; font-size: 18px;
            white-space: normal; word-break: break-word; overflow-wrap: anywhere;
            vertical-align: top; background: white; color: black; line-height: 1.5;
          }
          .ag-print-table tbody tr { page-break-inside: avoid; break-inside: avoid; }
          .ag-print-table-active .ag-root-wrapper { display: none !important; height: 0 !important; overflow: hidden !important; }
          @media print {
            .ag-print-table { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            .ag-print-table thead tr:first-child th { padding-top: 14px; }
            .ag-print-table-active .ag-root-wrapper { display: none !important; height: 0 !important; overflow: hidden !important; }
          }
        `;
        document.head.appendChild(s);
      }

      // Guard against duplicate table builds
      if (el.__printTable) return;

      const cols = this._getPrintColumns(api);
      if (!cols.length) return;

      // Build <colgroup>
      const colgroup = document.createElement('colgroup');
      for (const width of this._printColumnWidths(cols)) {
        const col = document.createElement('col');
        col.style.width = width + '%';
        colgroup.appendChild(col);
      }

      // Build <thead>
      const thead = document.createElement('thead');

      // Check for grouped header rows
      const groupRow = el.querySelector('.ag-header-row-column-group');
      if (groupRow) {
        const tr = document.createElement('tr');
        const groupCells = Array.from(groupRow.querySelectorAll('.ag-header-group-cell'));
        for (const gc of groupCells) {
          const th = document.createElement('th');
          const textEl = gc.querySelector('.ag-header-group-text');
          th.textContent = textEl ? textEl.textContent : gc.textContent || '';
          const span = gc.getAttribute('aria-colspan') || gc.getAttribute('colspan');
          if (span && parseInt(span) > 1) th.setAttribute('colspan', span);
          tr.appendChild(th);
        }
        thead.appendChild(tr);
      }

      // Leaf header row
      const headTr = document.createElement('tr');
      for (const c of cols) {
        const th = document.createElement('th');
        th.textContent = this._printHeaderText(el, c);
        headTr.appendChild(th);
      }
      thead.appendChild(headTr);

      // Build <tbody> from rendered rows
      const tbody = document.createElement('tbody');
      const centerContainer = el.querySelector('.ag-center-cols-container');
      const leftContainer = el.querySelector('.ag-pinned-left-cols-container');
      const rightContainer = el.querySelector('.ag-pinned-right-cols-container');
      if (!centerContainer) return;

      const centerRows = Array.from(centerContainer.querySelectorAll(':scope > .ag-row'));
      centerRows.sort((a, b) => {
        return parseInt(a.getAttribute('row-index') || '0') - parseInt(b.getAttribute('row-index') || '0');
      });

      const findRow = (container, refRow) => {
        if (!container) return null;
        const attrs = ['row-index', 'row-id', 'aria-rowindex'];
        for (const a of attrs) {
          const val = refRow.getAttribute(a);
          if (val != null) {
            const m = container.querySelector(`:scope > .ag-row[${a}='${val}']`);
            if (m) return m;
          }
        }
        return null;
      };

      // Helper: get display value for a cell via AG Grid API (bypasses DOM rendering issues)
      const getCellText = (rowNode, col) => {
        try {
          if (!rowNode || !rowNode.data) return '';
          const colDef = col.getColDef ? col.getColDef() : {};
          const field = colDef.field || (col.getColId ? col.getColId() : '');
          if (!field) return '';
          let value = colDef.context?.calculation
            ? api.getCellValue({ rowNode, colKey: col, useFormatter: false })
            : rowNode.data[field];
          if (value == null) return '';
          // Apply valueFormatter if present
          if (typeof colDef.valueFormatter === 'function') {
            try {
              value = colDef.valueFormatter({ value, data: rowNode.data, node: rowNode, colDef, column: col });
              if (value == null) return '';
            } catch (_e) {}
          } else if (colDef.cellRenderer === 'agCheckboxCellRenderer' && typeof value === 'boolean') {
            return value ? 'Yes' : 'No';
          }
          return String(value);
        } catch (_e) { return ''; }
      };

      for (const cRow of centerRows) {
        const lRow = findRow(leftContainer, cRow);
        const rRow = findRow(rightContainer, cRow);

        // Skip pinned-bottom rows (handled separately as totals below)
        if (cRow.getAttribute('row-pinned') === 'bottom') continue;

        // Resolve the AG Grid row node before identifying group rows. Group rows
        // do not consistently retain the ag-row-group DOM class in print layout.
        const rowIndex = parseInt(cRow.getAttribute('row-index') || '0');
        const rowNode = (typeof api.getDisplayedRowAtIndex === 'function') ? api.getDisplayedRowAtIndex(rowIndex) : null;
        const isFooter = !!rowNode?.footer || cRow.classList.contains('ag-row-footer') || cRow.classList.contains('ag-row-group-footer');
        const isGroup = !!rowNode?.group && !isFooter;

        // Group rows span the printable table, so the grouping value remains
        // visible even though AG Grid hides the grouped source column.
        if (isGroup) {
          const tr = document.createElement('tr');
          const td = document.createElement('td');
          td.setAttribute('colspan', String(cols.length));
          const groupCell = cRow.querySelector('.ag-group-value') || cRow.querySelector('.ag-cell-value') || cRow;
          const groupText = (groupCell.textContent || '').trim();
          td.textContent = groupText || this._groupRowLabel(rowNode);
          td.style.fontWeight = '600';
          tr.appendChild(td);
          tbody.appendChild(tr);
          continue;
        }

        const tr = document.createElement('tr');
        if (isFooter) {
          tr.style.fontWeight = '700';
          tr.style.borderTop = '2px solid #000';
        }
        for (const c of cols) {
          const colId = c.getColId ? c.getColId() : '';
          const pinned = c.getPinned ? c.getPinned() : null;
          const container = pinned === 'left' ? lRow : pinned === 'right' ? rRow : cRow;
          const td = document.createElement('td');

          // Try DOM extraction first
          let text = '';
          const colDef = c.getColDef ? c.getColDef() : {};
          const isCheckbox = colDef.cellRenderer === 'agCheckboxCellRenderer';
          if (container) {
            const cell = container.querySelector(`.ag-cell[col-id="${colId}"]`);
            if (cell) {
              const content = cell.querySelector('.ag-cell-value') || cell.querySelector('.ag-group-value') || cell;
              text = (content.textContent || '').trim();
            }
          }
          // Checkbox columns: convert true/false to Yes/No
          if (isCheckbox) {
            const lower = text.toLowerCase();
            if (lower === 'true' || lower === '1') text = 'Yes';
            else if (lower === 'false' || lower === '0' || !text) text = 'No';
          }
          // Fallback: get value directly from AG Grid API
          if (!text) {
            text = getCellText(rowNode, c);
          }

          td.textContent = text;
          tr.appendChild(td);
        }
        tbody.appendChild(tr);
      }

      // Floating bottom (totals) rows — merge into a single bold row
      const floatBottom = el.querySelector('.ag-floating-bottom-container');
      if (floatBottom) {
        const bottomRows = Array.from(floatBottom.querySelectorAll(':scope > .ag-row'));
        if (bottomRows.length) {
          // Collect cell values from all bottom rows, keeping non-empty values
          const merged = {};
          for (const bRow of bottomRows) {
            for (const c of cols) {
              const colId = c.getColId ? c.getColId() : '';
              const cell = bRow.querySelector(`.ag-cell[col-id="${colId}"]`);
              if (cell) {
                const content = cell.querySelector('.ag-cell-value') || cell.querySelector('.ag-group-value') || cell;
                const text = (content.textContent || '').trim();
                if (text && !merged[colId]) merged[colId] = text;
              }
            }
          }
          const tr = document.createElement('tr');
          tr.style.fontWeight = '700';
          tr.style.borderTop = '2px solid #000';
          for (const c of cols) {
            const colId = c.getColId ? c.getColId() : '';
            const td = document.createElement('td');
            td.textContent = merged[colId] || '';
            tr.appendChild(td);
          }
          tbody.appendChild(tr);
        }
      }

      // Assemble table
      const table = document.createElement('table');
      table.className = 'ag-print-table';
      table.id = `ag-print-table-${gridId}`;
      table.appendChild(colgroup);
      table.appendChild(thead);
      table.appendChild(tbody);

      // Hide AG Grid's div-based layout via class on parent (survives AG Grid DOM rebuilds)
      el.classList.add('ag-print-table-active');

      // Insert table in correct position (after label, before footer)
      const footer = el.querySelector('.jobcard-print-footer');
      if (footer) {
        el.insertBefore(table, footer);
      } else {
        el.appendChild(table);
      }

      el.__printTable = table;

      // Optional signature row at the end of the report (after the table, last page).
      // Forms opt in via data-print-signatories so other grids are unaffected.
      let signatories = [];
      try { signatories = el?.dataset?.printSignatories ? JSON.parse(el.dataset.printSignatories) : []; } catch (_e) {}
      if (signatories.length) {
        const sigEl = document.createElement('div');
        sigEl.className = 'ag-print-signatories';
        signatories.forEach(function (name) {
          const span = document.createElement('span');
          span.textContent = name;
          sigEl.appendChild(span);
        });
        table.parentNode.insertBefore(sigEl, table.nextSibling);
        el.__printSignatories = sigEl;
      }
    } catch (_e) {}
  },

  _removePrintTable: function (el) {
    try {
      if (!el) return;
      if (el.__printTable) {
        el.__printTable.remove();
        delete el.__printTable;
      }
      if (el.__printSignatories) {
        el.__printSignatories.remove();
        delete el.__printSignatories;
      }
      el.classList.remove('ag-print-table-active');
    } catch (_e) {}
  },

  _clearFixedRowHeights: function (el) {
    try {
      if (!el) return;
      const rows = el.querySelectorAll('.ag-row');
      rows.forEach(r => {
        try { r.style.removeProperty('height'); r.style.removeProperty('min-height'); r.style.removeProperty('max-height'); } catch (_e) {}
      });
      const cells = el.querySelectorAll('.ag-cell, .ag-cell-wrapper, .ag-cell-value, .ag-group-value');
      cells.forEach(c => {
        try { c.style.removeProperty('height'); c.style.removeProperty('min-height'); c.style.removeProperty('max-height'); c.style.removeProperty('overflow'); } catch (_e) {}
      });
    } catch (_e) {}
  },

  _formatPrintDate: function (v) {
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    if (!v) return '';
    var d = (v instanceof Date) ? v : new Date(v);
    if (isNaN(d.getTime())) return v;
    return String(d.getDate()).padStart(2,'0') + '-' + months[d.getMonth()] + '-' + d.getFullYear();
  },

  // Title bar printed above the grid: logo, company, title, filters and ISO codes.
  _buildPrintTitleBar: function (el) {
    let titleText = el?.dataset?.printTitle || '';
    if (!titleText) {
      const getFormNameFromEl = (node) => {
        if (!node) return '';
        if (node.dataset && node.dataset.formname) return node.dataset.formname;
        const withAttr = node.querySelector && node.querySelector('[data-formname]');
        if (withAttr && withAttr.getAttribute('data-formname')) return withAttr.getAttribute('data-formname');
        const formInput = node.querySelector && node.querySelector('input[name="formname"], [name="formname"]');
        if (formInput) return formInput.value || '';
        return '';
      };
      let current = el;
      while (!titleText && current) {
        titleText = getFormNameFromEl(current);
        current = current.parentElement;
      }
      if (!titleText) titleText = getFormNameFromEl(document);
    }
    if (!titleText) return null;
    const titleBar = document.createElement('div');
    titleBar.className = 'ag-print-titlebar';
    const logoSrc = el?.dataset?.printLogo ||
                    document.querySelector('img[data-client-logo]')?.src ||
                    document.querySelector('[data-client-logo]')?.getAttribute('data-client-logo') ||
                    document.querySelector('img.client-logo, img[alt*="logo" i]')?.getAttribute('src') || '';
    if (logoSrc) {
      const img = document.createElement('img');
      img.className = 'ag-print-logo';
      img.alt = 'Logo';
      img.src = logoSrc;
      titleBar.appendChild(img);
    }
    var companyEl = document.getElementById('client-company-data');
    var companyName = companyEl ? (companyEl.getAttribute('data-company-name') || '') : '';
    var companyAddress = companyEl ? (companyEl.getAttribute('data-company-address') || '') : '';
    if (companyName) {
      var cnNode = document.createElement('div');
      cnNode.className = 'ag-print-company-name';
      cnNode.textContent = companyName;
      titleBar.appendChild(cnNode);
    }
    if (companyAddress) {
      var caNode = document.createElement('div');
      caNode.className = 'ag-print-company-address';
      caNode.textContent = companyAddress;
      titleBar.appendChild(caNode);
    }
    const titleNode = document.createElement('div');
    titleNode.className = 'ag-print-title';
    titleNode.textContent = titleText;
    titleBar.appendChild(titleNode);

    const printSubtitle = el?.dataset?.printSubtitle || '';
    if (printSubtitle) {
      const subtitleNode = document.createElement('div');
      subtitleNode.className = 'ag-print-subtitle';
      subtitleNode.textContent = printSubtitle;
      titleBar.appendChild(subtitleNode);
    }

    // Date range (From / To) from filter inputs
    try {
      const startEl = document.querySelector('[name="start_date"]');
      const endEl = document.querySelector('[name="end_date"]');
      const fromDate = (startEl && startEl.value) ? this._formatPrintDate(startEl.value.trim()) : '';
      const toDate = (endEl && endEl.value) ? this._formatPrintDate(endEl.value.trim()) : '';
      if (fromDate || toDate) {
        const dateNode = document.createElement('div');
        dateNode.className = 'ag-print-subtitle';
        dateNode.textContent = 'From : ' + (fromDate || '') + '    TO : ' + (toDate || '');
        titleBar.appendChild(dateNode);
      }
    } catch (_e) {}

    try {
      const tabInput = document.querySelector('input[name="tab"]');
      const currentTab = tabInput ? tabInput.value : '';
      let subtitleText = '';
      if (currentTab === 'productionstatus') {
        const jobidEl = document.querySelector('#jobid_input') || document.querySelector('[name="jobid"]');
        const jobidVs = document.querySelector('#jobid[data-init="virtual-select"]');
        if (jobidVs) {
          const selectedValue = (jobidEl?.value || '').trim();
          const rawOptions = jobidVs.getAttribute('data-options') || '[]';
          try {
            const options = JSON.parse(rawOptions);
            const matched = options.find(function(opt) {
              return String(opt.value ?? '').trim() === selectedValue;
            });
            subtitleText = matched ? String(matched.label || matched.text || matched.value || '').trim() : '';
          } catch (_e) {}
        }
        if (!subtitleText && jobidEl) {
          const wrapper = jobidEl.closest('.vscomp-wrapper');
          if (wrapper) {
            const selectedOpt = wrapper.querySelector('.vscomp-option.selected, .vscomp-option.focused');
            subtitleText = selectedOpt ? (selectedOpt.getAttribute('data-label') || selectedOpt.textContent || '').trim() : '';
            if (!subtitleText) {
              const valueTxt = wrapper.querySelector('.vscomp-value')?.textContent || '';
              const valueSpan = wrapper.querySelector('.vscomp-value-tag-content');
              subtitleText = valueSpan ? valueSpan.textContent.trim() : valueTxt.trim();
            }
          } else {
            subtitleText = (jobidEl.options?.[jobidEl.selectedIndex]?.text || jobidEl.value || '').trim();
          }
        }
        if (subtitleText) subtitleText = 'JOBID: ' + subtitleText;
      } else if (currentTab === 'partwiseall') {
        const prodEl = document.querySelector('#prodgroup_input') || document.querySelector('[name="prodgroup"]');
        const prodVs = document.querySelector('#prodgroup[data-init="virtual-select"]');
        if (prodVs) {
          const selectedValue = (prodEl?.value || '').trim();
          const rawOptions = prodVs.getAttribute('data-options') || '[]';
          try {
            const options = JSON.parse(rawOptions);
            const matched = options.find(function(opt) {
              return String(opt.value ?? '').trim() === selectedValue;
            });
            subtitleText = matched ? String(matched.label || matched.text || matched.value || '').trim() : '';
          } catch (_e) {}
        }
        if (!subtitleText && prodEl) {
          const wrapper = prodEl.closest('.vscomp-wrapper');
          if (wrapper) {
            const selectedOpt = wrapper.querySelector('.vscomp-option.selected, .vscomp-option.focused');
            subtitleText = selectedOpt ? (selectedOpt.getAttribute('data-label') || selectedOpt.textContent || '').trim() : '';
            if (!subtitleText) {
              const valueTxt = wrapper.querySelector('.vscomp-value')?.textContent || '';
              const valueSpan = wrapper.querySelector('.vscomp-value-tag-content');
              subtitleText = valueSpan ? valueSpan.textContent.trim() : valueTxt.trim();
            }
          } else {
            subtitleText = (prodEl.options?.[prodEl.selectedIndex]?.text || prodEl.value || '').trim();
          }
        }
      }
      if (subtitleText) {
        const subNode = document.createElement('div');
        subNode.className = 'ag-print-subtitle';
        subNode.textContent = subtitleText;
        titleBar.appendChild(subNode);
      }
    } catch (_e) {}
    const isoNode = document.createElement('div');
    isoNode.className = 'ag-print-iso-label';
    const reportCodes = el?.dataset?.reportCodes ? JSON.parse(el.dataset.reportCodes) : [];
    if (reportCodes.length > 0) {
      isoNode.appendChild(document.createTextNode('ISO Code - '));
      reportCodes.forEach(function(code, idx) {
        if (idx > 0) isoNode.appendChild(document.createElement('br'));
        var span = document.createElement('span');
        span.className = 'ag-print-iso-code';
        span.textContent = code;
        isoNode.appendChild(span);
      });
    }
    titleBar.appendChild(isoNode);
    return titleBar;
  },

  setPrintLayout: function (elOrId) {
    const el = this._resolveGridElement(elOrId);
    if (!el) return;
    const gridId = el.dataset.agId;
    const api = window[`aggridApi:${gridId}`];
    if (!api) return;

    const wrapper = el;
    el.__printState = {
      width: wrapper.style.width,
      height: wrapper.style.height,
      sideBarVisible: undefined,
    };
    try {
      if (typeof api.isSideBarVisible === 'function' && typeof api.setSideBarVisible === 'function') {
        el.__printState.sideBarVisible = api.isSideBarVisible();
        api.setSideBarVisible(false);
      }
      if (typeof api.expandAll === 'function') api.expandAll();
    } catch (_e) {}

    try {
      const viewports = Array.from(el.querySelectorAll('.ag-body-viewport, .ag-center-cols-viewport'));
      el.__printScroll = {
        pageX: window.scrollX,
        pageY: window.scrollY,
        viewports: viewports.map(v => ({ node: v, top: v.scrollTop, left: v.scrollLeft })),
      };
      try { window.scrollTo(0, 0); } catch (_e) {}
      for (const v of viewports) {
        try { v.scrollTop = 0; v.scrollLeft = 0; } catch (_e) {}
      }
    } catch (_e) {}

    api.setGridOption('domLayout', 'print');

    wrapper.style.width = '';
    wrapper.style.height = '';

    this._relaxAncestorsForPrint(wrapper);
    this._hideNonGridSiblings(wrapper);

    if (!document.getElementById('ag-print-style')) {
      const style = document.createElement('style');
      style.id = 'ag-print-style';
      style.textContent = `@media print {
        html, body { height: auto !important; overflow: visible !important; margin: 0 !important; padding: 0 !important; }
      
        [data-ag-id] .ag-root-wrapper {
          border: 3px solid #888 !important;
        }
      
        [data-ag-id], .ag-root-wrapper, .ag-root, .ag-center-cols-viewport, .ag-center-cols-container,
        .ag-body, .ag-body-viewport, .ag-body-vertical-scroll,
        .ag-body-vertical-scroll-viewport, .ag-body-horizontal-scroll,
        .ag-body-horizontal-scroll-viewport {
          height: auto !important;
          max-height: none !important;
          overflow: visible !important;
        }
      
        .ag-print-controls { display: none !important; }
      }`;
      document.head.appendChild(style);
    }

    if (!document.getElementById('ag-print-page-style')) {
      const pageStyle = document.createElement('style');
      pageStyle.id = 'ag-print-page-style';
      pageStyle.textContent = `@page { size: landscape; margin: 0.25in; }`;
      document.head.appendChild(pageStyle);
    }

    try {
      el.__printState.pagination = !!api.getGridOption('pagination');
      if (el.__printState.pagination) {
        api.setGridOption('pagination', false);
      }
    } catch (_e) {}

    const focusStyleId = `ag-print-focus-style-${gridId}`;
    if (!document.getElementById(focusStyleId)) {
      const s = document.createElement('style');
      s.id = focusStyleId;
      s.textContent = `@media print {\n  html, body { margin: 0 !important; padding: 0 !important; background: white !important; }\n  body * { visibility: hidden !important; }\n  [data-ag-id='${gridId}'] { visibility: visible !important; position: static !important; width: 100% !important; margin: 0 !important; padding: 0 !important; }\n  [data-ag-id='${gridId}'] * { visibility: visible !important; }\n  [data-ag-id='${gridId}'] .ag-root-wrapper { position: static !important; min-width: 100% !important; margin: 0 !important; padding: 0 !important; border: none !important; background: white !important; }\n  [data-ag-id='${gridId}'].ag-print-table-active .ag-root-wrapper,\n  [data-ag-id='${gridId}'].ag-print-table-active .ag-root-wrapper * { display: none !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important; }\n  [data-ag-id='${gridId}'].ag-print-table-active .ag-row-group-panel,\n  [data-ag-id='${gridId}'].ag-print-table-active .ag-side-bar,\n  [data-ag-id='${gridId}'].ag-print-table-active .ag-floating-filter,\n  [data-ag-id='${gridId}'].ag-print-table-active .ag-status-bar,\n  [data-ag-id='${gridId}'].ag-print-table-active .ag-selection-checkbox { display: none !important; }\n  /* tighten header spacing */\n  [data-ag-id='${gridId}'] .ag-header,\n  [data-ag-id='${gridId}'] .ag-header-viewport { margin: 0 !important; padding: 0 !important; height: 24px !important; min-height: 24px !important; }\n  [data-ag-id='${gridId}'] .ag-header-row { height: 24px !important; min-height: 24px !important; }\n  [data-ag-id='${gridId}'] .ag-header-cell,\n  [data-ag-id='${gridId}'] .ag-cell { padding-top: 0 !important; padding-bottom: 0 !important; }\n}`;
      document.head.appendChild(s);
    }

    try { document.body.classList.add('ag-printing'); } catch (_e) {}

    // Optional print title/logo injection
    try {
      if (!document.getElementById('ag-print-title-style')) {
        const ts = document.createElement('style');
        ts.id = 'ag-print-title-style';
        ts.textContent = `@media print { .ag-print-titlebar { position: relative; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px; margin: 8px 0 8px 0; padding-top: 4px; min-height: 96px; } .ag-print-company-name { text-align: center; font-weight: 800; font-size: 36px; text-transform: uppercase; } .ag-print-company-address { text-align: center; font-size: 20px; color: #333; margin-bottom: 2px; } .ag-print-title { text-align: center; font-weight: 800; font-size: 34px; } .ag-print-subtitle { text-align: center; font-weight: 700; font-size: 24px; margin-top: 2px; } .ag-print-logo { position: absolute; left: 16px; top: 50%; transform: translateY(-50%); max-height: 96px; max-width: 220px; height: auto; width: auto; object-fit: contain; }
        .ag-print-iso-label {
        position: absolute;
        top: -4px;
        right: 30px;
        color: #000;
        font-weight: 700;
        font-size: 22px;
        line-height: 1.4;
        text-align: right;
    }

    .ag-print-iso-code {
        font-weight: 700;
        font-size: 22px;
        line-height: 1.4;
    }
    .ag-print-iso-code + .ag-print-iso-code {
        display: block;
    }
    .ag-print-footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: right;
        font-size: 9px;
        color: #000;
        padding: 4px 10px;
        border-top: 1px solid #ccc;
        visibility: visible !important;
        z-index: 99999;
    }
    .ag-print-signatories {
        display: flex;
        justify-content: space-between;
        margin-top: 150px;
        padding-top: 16px;
        border-top: 1px solid #000;
        font-size: 20px;
        font-weight: 700;
        page-break-inside: avoid;
        break-inside: avoid;
    }
    .ag-print-signatories span { min-width: 14%; text-align: center; }
        } }`;
        document.head.appendChild(ts);
      }
      const titleId = `ag-print-title-${gridId}`;
      if (!document.getElementById(titleId)) {
        const titleBar = this._buildPrintTitleBar(el);
        if (titleBar) {
          titleBar.id = titleId;
          el.insertBefore(titleBar, el.firstChild);
        }
      }
      if (document.getElementById(titleId)) el.__printTitleId = titleId;

      // Print footer with timestamp
      const footerId = `ag-print-footer-${gridId}`;
      if (!document.getElementById(footerId)) {
        const now = new Date();
        const hh = String(now.getHours()).padStart(2, '0');
        const mi = String(now.getMinutes()).padStart(2, '0');
        const footerEl = document.createElement('div');
        footerEl.id = footerId;
        footerEl.className = 'ag-print-footer';
        footerEl.textContent = 'Printed On : ' + this._formatPrintDate(now) + ' ' + hh + ':' + mi + '   Generated Using Smaac-Steel';
        document.body.appendChild(footerEl);
        el.__printFooterId = footerId;
      }
    } catch (_e) {}

    const wrapStyleId = `ag-print-wrap-style-${gridId}`;
    if (!document.getElementById(wrapStyleId)) {
      const ws = document.createElement('style');
      ws.id = wrapStyleId;
      ws.textContent = `@media print {\n  /* ensure all grid text increases, not just the wrapper */\n  [data-ag-id='${gridId}'] .ag-root-wrapper,\n  [data-ag-id='${gridId}'] .ag-root,\n  [data-ag-id='${gridId}'] .ag-body,\n  [data-ag-id='${gridId}'] .ag-body-viewport,\n  [data-ag-id='${gridId}'] .ag-center-cols-viewport,\n  [data-ag-id='${gridId}'] .ag-center-cols-container,\n  [data-ag-id='${gridId}'] .ag-cell,\n  [data-ag-id='${gridId}'] .ag-cell-value,\n  [data-ag-id='${gridId}'] .ag-header-cell-label,\n  [data-ag-id='${gridId}'] .ag-header-cell-text {\n    font-size: 18px !important;\n  }\n  /* hide grouping panel and placeholders in print */\n  [data-ag-id='${gridId}'] .ag-row-group-panel,\n  [data-ag-id='${gridId}'] .ag-column-drop,\n  [data-ag-id='${gridId}'] .ag-column-drop-empty-message {\n    display: none !important;\n  }\n  [data-ag-id='${gridId}'] .ag-cell,\n  [data-ag-id='${gridId}'] .ag-header-cell-label,\n  [data-ag-id='${gridId}'] .ag-header-cell-text {\n    white-space: normal !important;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n    line-height: 1.5;\n  }\n  /* make headers larger and bold for print */\n  [data-ag-id='${gridId}'] .ag-header-cell-text,\n  [data-ag-id='${gridId}'] .ag-header-group-cell-label .ag-header-group-text {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n  }\n  [data-ag-id='${gridId}'] .ag-cell,\n  [data-ag-id='${gridId}'] .ag-header-cell-label { padding: 6px 8px !important; }\n  /* header text: no clamp or ellipsis in print */\n  [data-ag-id='${gridId}'] .ag-header-cell-text {\n    display: block;\n    -webkit-line-clamp: unset;\n    -webkit-box-orient: unset;\n    overflow: visible !important;\n    text-overflow: clip !important;\n    line-height: 1.3;\n    max-height: none;\n  }\n  /* hide sort icons to free space */\n  [data-ag-id='${gridId}'] .ag-sort-indicator,\n  [data-ag-id='${gridId}'] .ag-header-icon {\n    display: none !important;\n  }\n  /* ensure header containers can grow and not clip */
    [data-ag-id='${gridId}'] .ag-header,
    [data-ag-id='${gridId}'] .ag-header-viewport,
    [data-ag-id='${gridId}'] .ag-header-row,
    [data-ag-id='${gridId}'] .ag-header-cell,
    [data-ag-id='${gridId}'] .ag-header-cell-label { overflow: visible !important; }
    /* header text: wrap at word boundaries only — never break mid-word */
    [data-ag-id='${gridId}'] .ag-header-cell-text,
    [data-ag-id='${gridId}'] .ag-header-cell-label {
      word-break: normal !important;
      overflow-wrap: normal !important;
      hyphens: none !important;
    }
    /* add slight breathing room on top to prevent header text being cut */
    [data-ag-id='${gridId}'] .ag-header,
    [data-ag-id='${gridId}'] .ag-header-row,
    [data-ag-id='${gridId}'] .ag-header-cell-label,
    [data-ag-id='${gridId}'] .ag-header-group-cell-label { padding-top: 4px !important; }
    /* remove extra space below headers */
    [data-ag-id='${gridId}'] .ag-header,
    [data-ag-id='${gridId}'] .ag-header-viewport,
    [data-ag-id='${gridId}'] .ag-header-row,
    [data-ag-id='${gridId}'] .ag-header-cell,
    [data-ag-id='${gridId}'] .ag-header-cell-label { padding-bottom: 0 !important; margin-bottom: 0 !important; }
    [data-ag-id='${gridId}'] .ag-cell-value {
      display: block !important;
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
      line-height: 1.5 !important;
      -webkit-line-clamp: unset !important;
      -webkit-box-orient: unset !important;
      max-height: none !important;
      word-break: break-word;
      overflow-wrap: anywhere;
    }
    [data-ag-id='${gridId}'] .ag-group-value {
      display: block !important;
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
      line-height: 1.5 !important;
      max-height: none !important;
      word-break: break-word;
      overflow-wrap: anywhere;
    }
    /* ensure cells can grow and text starts at top */
    [data-ag-id='${gridId}'] .ag-cell {
      align-items: flex-start !important;
      height: auto !important;
      overflow: visible !important;
    }
    [data-ag-id='${gridId}'] .ag-cell-wrapper {
      align-items: flex-start !important;
      height: auto !important;
      white-space: normal !important;
      overflow: visible !important;
      width: 100% !important;
    }
    /* enforce static flow so row height matches tallest cell and next row starts after */
    [data-ag-id='${gridId}'] .ag-center-cols-container,
    [data-ag-id='${gridId}'] .ag-pinned-left-cols-container,
    [data-ag-id='${gridId}'] .ag-pinned-right-cols-container,
    [data-ag-id='${gridId}'] .ag-center-cols-clipper {
      height: auto !important;
      min-height: auto !important;
      overflow: visible !important;
      position: static !important;
      transform: none !important;
    }
    [data-ag-id='${gridId}'] .ag-row,
    [data-ag-id='${gridId}'] .ag-row-position-absolute {
      position: static !important;
      top: auto !important;
      transform: none !important;
      align-items: stretch !important;
      overflow: visible !important;
      page-break-inside: avoid !important;
      break-inside: avoid !important;
    }
    /* Print must be white background + black text only -- strip all
       row/cell coloring (e.g. Production done, Already added, Item on hold) */
    [data-ag-id='${gridId}'] .ag-row,
    [data-ag-id='${gridId}'] .ag-row-position-absolute,
    [data-ag-id='${gridId}'] .ag-cell,
    [data-ag-id='${gridId}'] .ag-cell-value,
    [data-ag-id='${gridId}'] .ag-cell-wrapper,
    [data-ag-id='${gridId}'] .ag-group-value {
      background: white !important;
      background-color: white !important;
      color: black !important;
    }
    /* increase header/row heights to prevent clipping */
    [data-ag-id='${gridId}'] .ag-header,
    [data-ag-id='${gridId}'] .ag-header-viewport,
    [data-ag-id='${gridId}'] .ag-header-row { height: auto !important; min-height: 56px !important; page-break-inside: avoid; break-inside: avoid; }
    [data-ag-id='${gridId}'] .ag-row { height: auto; page-break-inside: avoid; break-inside: avoid; }
    [data-ag-id='${gridId}'] .ag-center-cols-viewport { padding-top: 0 !important; margin-top: 0 !important; }
    /* table-like borders for clear record segregation */
    [data-ag-id='${gridId}'] .ag-root-wrapper { border: 1px solid #d1d5db !important; }
    /* avoid overlap with first row: no bottom border on header row */
    [data-ag-id='${gridId}'] .ag-header-row { border-bottom: 0 !important; }
    /* header top spacing and container border adjustments */
    [data-ag-id='${gridId}'] .ag-header { position: relative !important; margin-top: 0 !important; border-top: 0 !important; }
    /* remove extra divider line under header (we will use header cell bottom borders) */
    [data-ag-id='${gridId}'] .ag-header::after { content: none !important; }
    /* CRISP, UNIFORM BORDERS ----------------------------------------------- */
    /* Header cells: draw right + bottom borders; first header cell also draws left */
    [data-ag-id='${gridId}'] .ag-header-cell,
    [data-ag-id='${gridId}'] .ag-header-group-cell {
      border: 1px solid #cbd5e1 !important; /* all sides for clear gridlines */
      box-sizing: border-box !important;
    }
    /* Body cells: draw right + bottom borders; first body cell in each row also draws left; no top border to avoid double line under header */
    [data-ag-id='${gridId}'] .ag-center-cols-container .ag-cell,
    [data-ag-id='${gridId}'] .ag-pinned-left-cols-container .ag-cell,
    [data-ag-id='${gridId}'] .ag-pinned-right-cols-container .ag-cell {
      border: 1px solid #cbd5e1 !important; /* all sides for clear gridlines */
      box-sizing: border-box !important;
    }
    /* Pinned boundaries: no extra separators; cell borders already draw lines */
    [data-ag-id='${gridId}'] .ag-pinned-left-header,
    [data-ag-id='${gridId}'] .ag-pinned-left-cols-container { border-right: 0 !important; }
    [data-ag-id='${gridId}'] .ag-pinned-right-header,
    [data-ag-id='${gridId}'] .ag-pinned-right-cols-container { border-left: 0 !important; }
    /* remove row-level borders to avoid double-thick lines */
    [data-ag-id='${gridId}'] .ag-center-cols-container .ag-row,
    [data-ag-id='${gridId}'] .ag-pinned-left-cols-container .ag-row,
    [data-ag-id='${gridId}'] .ag-pinned-right-cols-container .ag-row { border: 0 !important; }
    /* rely on uniform cell borders; no special first-row rule */
    [data-ag-id='${gridId}'] .ag-center-cols-container .ag-row:first-child .ag-cell,
    [data-ag-id='${gridId}'] .ag-pinned-left-cols-container .ag-row:first-child .ag-cell,
    [data-ag-id='${gridId}'] .ag-pinned-right-cols-container .ag-row:first-child .ag-cell { border-top-width: 1px !important; }
    /* ensure colors render as specified in print */
    [data-ag-id='${gridId}'] { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    /* Hide header resize handles in print to avoid short stray vertical ticks */
    [data-ag-id='${gridId}'] .ag-header-cell-resize,
    [data-ag-id='${gridId}'] .ag-header-cell-resize-line { display: none !important; }
    /* Remove floating filter row and any vertical gap */
    [data-ag-id='${gridId}'] .ag-header-row.ag-header-row-floating-filter,
    [data-ag-id='${gridId}'] .ag-floating-filter,
    [data-ag-id='${gridId}'] .ag-floating-filter-body { display: none !important; height: 0 !important; min-height: 0 !important; padding: 0 !important; margin: 0 !important; border: 0 !important; }
    [data-ag-id='${gridId}'] .ag-header-viewport { height: auto !important; min-height: auto !important; padding-bottom: 0 !important; margin-bottom: 0 !important; }
    [data-ag-id='${gridId}'] .ag-header-container { padding-bottom: 0 !important; margin-bottom: 0 !important; }
    [data-ag-id='${gridId}'] .ag-center-cols-viewport { padding-top: 0 !important; margin-top: 0 !important; }
    /* Improve header text legibility versus borders */
    [data-ag-id='${gridId}'] .ag-header-cell-label,
    [data-ag-id='${gridId}'] .ag-header-group-cell-label { padding: 6px 8px 6px 8px !important; line-height: 1.2 !important; background: white !important; }
    /* Nudge header text slightly upward to clear the bottom border */
    [data-ag-id='${gridId}'] .ag-header-cell-text { position: relative; top: -0.5px; }
    /* HEADER BORDERS (print-only): slim and crisp */
    [data-ag-id='${gridId}'] .ag-header-cell,
    [data-ag-id='${gridId}'] .ag-header-group-cell {
      border: 0 !important; /* no top/bottom borders on headers */
      border-right: 1px solid #cbd5e1 !important; /* vertical separators */
      box-sizing: border-box !important;
      background: #ffffff !important;
    }
    /* avoid double line at far right edge */
    [data-ag-id='${gridId}'] .ag-header-row .ag-header-cell:last-child,
    [data-ag-id='${gridId}'] .ag-header-row .ag-header-group-cell:last-child { border-right: 0 !important; }
    [data-ag-id='${gridId}'] .ag-header-row .ag-header-cell:first-child,
    [data-ag-id='${gridId}'] .ag-header-row .ag-header-group-cell:first-child { border-left: 0 !important; }
    /* Container border (outer frame) - DARK in print view */
    [data-ag-id='${gridId}'] .ag-root-wrapper { border: 3px solid #888 !important; }
    /* Hide header resize handles to avoid stray ticks */
    [data-ag-id='${gridId}'] .ag-header-cell-resize,
    [data-ag-id='${gridId}'] .ag-header-cell-resize-line { display: none !important; }
    /* ensure colors render as specified in print */
    [data-ag-id='${gridId}'] { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    /* Ensure checkboxes print clearly (selection stays hidden elsewhere) */
    [data-ag-id='${gridId}'] .ag-checkbox-input-wrapper,
    [data-ag-id='${gridId}'] .ag-checkbox-input,
    [data-ag-id='${gridId}'] input[type='checkbox'] {
      -webkit-appearance: none !important;
      appearance: none !important;
      width: 12px !important;
      height: 12px !important;
      border: 1px solid #374151 !important; /* gray-700 */
      border-radius: 2px !important;
      background: #ffffff !important;
      display: inline-block !important;
      position: relative !important;
      vertical-align: middle !important;
    }
 }`;
      document.head.appendChild(ws);
    }

    try { api.resetRowHeights?.(); } catch (_e) {}

    try {
      // Apply max width constraints if provided on the grid element
      try { this._applyPrintMaxWidths(el); } catch (_e) {}
      setTimeout(() => {
        if (!el.__printState) return;
        try {
          api.refreshClientSideRowModel('everything');
          api.redrawRows();
          // Build a proper HTML table for print (enables header repetition + text wrapping)
          this._buildPrintTable(el);
        } catch (_e) {}
      }, 0);
    } catch (_e) {}
  },

  resetPrintLayout: function (elOrId) {
    const el = this._resolveGridElement(elOrId);
    if (!el) return;
    const gridId = el.dataset.agId;
    const api = window[`aggridApi:${gridId}`];
    if (!api) return;
    // Remove the print table and restore AG Grid's div layout
    this._removePrintTable(el);
    // Snapshot state up-front so we can safely restore later
    const prevState = el.__printState ? { ...el.__printState } : null;
    api.setGridOption('domLayout', undefined);

    if (prevState) {
      el.style.width = prevState.width;
      el.style.height = prevState.height;
      try {
        if (typeof prevState.sideBarVisible === 'boolean' && typeof api.setSideBarVisible === 'function') {
          api.setSideBarVisible(prevState.sideBarVisible);
        }
      } catch (_e) {}
    }

    this._restoreAncestorsAfterPrint(el);
    this._restoreHiddenSiblings(el);
    this._clearFixedRowHeights(el);
    try { this._restorePrintMaxWidths(el); } catch (_e) {}

    try {
      if (el.__printScroll) {
        try { window.scrollTo(el.__printScroll.pageX || 0, el.__printScroll.pageY || 0); } catch (_e) {}
        for (const s of (el.__printScroll.viewports || [])) {
          try { s.node.scrollTop = s.top; s.node.scrollLeft = s.left; } catch (_e) {}
        }
        delete el.__printScroll;
      }
    } catch (_e) {}

    const style = document.getElementById('ag-print-style');
    if (style && style.parentNode) style.parentNode.removeChild(style);

    const pageStyle = document.getElementById('ag-print-page-style');
    if (pageStyle && pageStyle.parentNode) pageStyle.parentNode.removeChild(pageStyle);

    try {
      const focusStyleId = `ag-print-focus-style-${gridId}`;
      const fs = document.getElementById(focusStyleId);
      if (fs && fs.parentNode) fs.parentNode.removeChild(fs);
      document.body.classList.remove('ag-printing');
    } catch (_e) {}
    try {
      if (prevState && prevState.pagination === true) {
        api.setGridOption('pagination', true);
      }
    } catch (_e) {}

    try {
      const toRestore = (prevState && Array.isArray(prevState.hiddenSelectionCols)) ? prevState.hiddenSelectionCols : [];
      toRestore.forEach(colKey => {
        try { api.setColumnVisible(colKey, true); } catch (_e) {}
      });
    } catch (_e) {}

    try {
      const wrap = document.getElementById(`ag-print-wrap-style-${gridId}`);
      if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
    } catch (_e) {}

    try {
      const titleId = el.__printTitleId;
      if (titleId) {
        const t = document.getElementById(titleId);
        if (t && t.parentNode) t.parentNode.removeChild(t);
        delete el.__printTitleId;
      }
      const footerId = el.__printFooterId;
      if (footerId) {
        const f = document.getElementById(footerId);
        if (f && f.parentNode) f.parentNode.removeChild(f);
        delete el.__printFooterId;
      }
    } catch (_e) {}
    // Clear rowSpan caches keyed by prior row indexes and force a full refresh
    // so cell borders/lines re-render consistently after leaving print layout.
    try {
      const colDefs = (typeof api.getColumnDefs === 'function')
        ? api.getColumnDefs()
        : (api?.gridOptionsWrapper?.gridOptions?.columnDefs || []);
      if (Array.isArray(colDefs)) {
        colDefs.forEach(cd => {
          if (cd && cd.rowSpanValue) {
            try { cd.rowSpanValue = {}; } catch (_e) {}
          }
        });
      }
      try { api.refreshClientSideRowModel('everything'); } catch (_e) {}
      try { api.redrawRows({ force: true }); } catch (_e) {}
      try { api.resetRowHeights?.(); } catch (_e) {}
    } catch (_e) {}
    requestAnimationFrame(() => {
      api.doLayout?.();
      const pinnedBottomRows = api.getGridOption?.('pinnedBottomRowData');
      if (pinnedBottomRows?.length) api.setGridOption('pinnedBottomRowData', pinnedBottomRows);
    });
    // Clear stored print state at the very end
    try { delete el.__printState; } catch (_e) {}
  },

  // ----- Large grids: a worker renders the preview PDF (#9910) -----------------
  // The print layout renders every row in the page, which hangs the browser on
  // a large grid. Above the row limit set by the grid template, the displayed
  // rows are read from the grid API and sent to ssr/pages/gridprint.py instead.

  _shouldPrintOnServer: function (el, api) {
    const browserMaxRows = Number(el.dataset.printBrowserMaxRows);
    if (!browserMaxRows) return false;
    // Printing shows the rows of every group, as setPrintLayout does.
    if (typeof api.expandAll === 'function') api.expandAll();
    return api.getDisplayedRowCount() > browserMaxRows;
  },

  _printValueText: function (api, rowNode, col) {
    const value = api.getCellValue({ rowNode, colKey: col, useFormatter: true });
    return value == null ? '' : String(value);
  },

  _printCellText: function (api, rowNode, col) {
    const text = this._printValueText(api, rowNode, col);
    const colDef = col.getColDef ? col.getColDef() : {};
    if (colDef.cellRenderer !== 'agCheckboxCellRenderer') return text;
    const lower = text.toLowerCase();
    return (lower === 'true' || lower === '1') ? 'Yes' : 'No';
  },

  // Read from the column tree: the header DOM only holds the columns that are
  // scrolled into view.
  _printHeaderGroups: function (api, cols) {
    const groups = [];
    for (const col of cols) {
      let group = col.getParent ? col.getParent() : null;
      while (group && group.getParent && group.getParent()) group = group.getParent();
      const last = groups[groups.length - 1];
      if (last && last.group === group) {
        last.span += 1;
      } else {
        groups.push({ group, span: 1 });
      }
    }
    const labelled = groups.map(({ group, span }) => ({
      label: (group && api.getDisplayNameForColumnGroup(group, 'header')) || '',
      span,
    }));
    return labelled.some(group => group.label) ? labelled : [];
  },

  _collectPrintTable: async function (el, api, onProgress) {
    const cols = this._getPrintColumns(api);
    const widths = this._printColumnWidths(cols);
    const nodes = [];
    const rowCount = api.getDisplayedRowCount();
    for (let index = 0; index < rowCount; index++) {
      const node = api.getDisplayedRowAtIndex(index);
      if (node) nodes.push(node);
    }
    const rows = [];
    for (let index = 0; index < nodes.length; index++) {
      const node = nodes[index];
      if (node.group && !node.footer) {
        rows.push({ kind: 'group', cells: [this._groupRowLabel(node)] });
      } else {
        rows.push({
          kind: node.footer ? 'total' : 'row',
          cells: cols.map(col => this._printCellText(api, node, col)),
        });
      }
      // Let the browser repaint so the loading panel keeps moving.
      if (index % 2000 === 1999) {
        if (onProgress) onProgress(index + 1, nodes.length);
        await new Promise(resolve => setTimeout(resolve));
      }
    }
    // Pinned bottom (totals) rows are merged into one row, as in _buildPrintTable.
    const bottomCount = api.getPinnedBottomRowCount();
    const totals = cols.map(() => '');
    for (let index = 0; index < bottomCount; index++) {
      const node = api.getPinnedBottomRow(index);
      cols.forEach((col, position) => {
        if (!totals[position]) totals[position] = this._printValueText(api, node, col);
      });
    }
    return {
      // The PDF page widens to the grid's on-screen width, so many columns
      // keep their proportions instead of being squeezed into A4.
      total_width: Math.round(cols.reduce(
        (sum, col) => sum + (col.getActualWidth ? col.getActualWidth() : 100), 0)),
      columns: cols.map((col, position) => ({
        header: this._printHeaderText(el, col),
        width: widths[position],
        align: this._printColumnAlign(col),
      })),
      header_groups: this._printHeaderGroups(api, cols),
      rows,
      totals: bottomCount ? totals : [],
    };
  },

  _collectPrintHeader: function (el) {
    const titleBar = this._buildPrintTitleBar(el);
    const texts = selector => (titleBar
      ? Array.from(titleBar.querySelectorAll(selector), node => node.textContent || '')
      : []);
    return {
      title: texts('.ag-print-title')[0] || '',
      subtitles: texts('.ag-print-subtitle'),
      report_codes: texts('.ag-print-iso-code'),
      signatories: el.dataset.printSignatories ? JSON.parse(el.dataset.printSignatories) : [],
    };
  },

  _printJobRequest: async function (url, options) {
    const token = document.querySelector('[name="apitoken"]')?.value;
    const target = new URL(url, window.location.origin);
    if (token) target.searchParams.set('apitoken', token);
    const response = await fetch(target, {
      credentials: 'same-origin',
      ...options,
      headers: { Prefer: 'response_ctype=json', ...(options && options.headers) },
    });
    if (!response.ok) {
      const error = new Error(`Grid preview request failed: ${response.status}`);
      // A rejected preview (for example too many rows) carries the form errors.
      if (response.status === 400) error.formErrors = await response.json();
      throw error;
    }
    return response;
  },

  _setPrintLoadingDetail: function (el, text) {
    const detail = el.querySelector('.ag-print-loading [data-print-loading-detail]');
    if (detail) detail.textContent = text;
  },

  _printCancelError: function () {
    const error = new Error('Grid Preview cancelled');
    error.printCancelled = true;
    return error;
  },

  _throwIfPrintCancelled: function (el) {
    if (el.__printCancelRequested) throw this._printCancelError();
  },

  // Shows the Cancel button and binds it plus the Escape key. Returns the
  // unbind function for the flow's finally block.
  _enablePrintCancel: function (el) {
    const button = el.querySelector('.ag-print-loading [data-print-cancel]');
    if (!button) return () => {};
    const cancel = () => {
      el.__printCancelRequested = true;
      el.__printAbort?.abort();
      this._setPrintLoadingDetail(el, 'Cancelling.');
    };
    const onKeydown = event => {
      if (event.key === 'Escape') cancel();
    };
    button.classList.remove('hidden');
    button.addEventListener('click', cancel, { once: true });
    document.addEventListener('keydown', onKeydown);
    button.focus();
    return () => document.removeEventListener('keydown', onKeydown);
  },

  // One bar for the whole flow: reading the grid is the first 15%, the
  // worker's rendering the next 80%, opening the preview the rest.
  _setPrintProgress: function (el, percent) {
    const fill = el.querySelector('.ag-print-loading [data-print-loading-fill]');
    if (fill) fill.style.width = `${Math.min(100, Math.max(3, percent))}%`;
  },

  // A sleep that ends immediately when the user cancels.
  _printDelay: function (el, ms) {
    return new Promise(resolve => {
      const signal = el.__printAbort?.signal;
      if (!signal || signal.aborted) {
        setTimeout(resolve, signal ? 0 : ms);
        return;
      }
      const onAbort = () => {
        clearTimeout(timer);
        resolve();
      };
      const timer = setTimeout(() => {
        signal.removeEventListener('abort', onAbort);
        resolve();
      }, ms);
      signal.addEventListener('abort', onAbort, { once: true });
    });
  },

  _waitForPrintJob: async function (el, jobId) {
    for (;;) {
      await this._printDelay(el, 2000);
      this._throwIfPrintCancelled(el);
      const response = await this._printJobRequest(
        `${el.dataset.printJobUrl}?job_id=${jobId}`,
        { method: 'GET', signal: el.__printAbort?.signal });
      const job = await response.json();
      if (job.state === 'done') return;
      if (job.state !== 'queued' && job.state !== 'running') {
        throw new Error(`Grid preview job ${job.state}`);
      }
      if (job.state === 'running' && job.total) {
        this._setPrintProgress(el, 15 + (job.done / job.total) * 80);
      }
    }
  },

  _showPdfPreview: async function (el, pdfBlob, filename) {
    if (typeof window.showPreview !== 'function') {
      // printable.js owns the PDF preview dialog; pages without a print form do not load it.
      const css = el.dataset.printPreviewCss;
      if (!document.querySelector(`link[href="${css}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = css;
        document.head.appendChild(link);
      }
      await loadScript(el.dataset.printPreviewJs);
    }
    // The dialog's Excel button exports a print form; the grid has its own export.
    window.showPreview(pdfBlob, filename, { sourceEl: el, excelExport: false })
      .catch(error => window.Bugsink?.captureException?.(error));
  },

  _printOnServer: async function (el, api) {
    const rowCount = api.getDisplayedRowCount();
    const maxRows = Number(el.dataset.printMaxRows);
    if (rowCount > maxRows) {
      window.showFlashMessage(
        null,
        'warning',
        `This grid has ${rowCount.toLocaleString()} rows. Grid Preview supports up to `
          + `${maxRows.toLocaleString()} rows; please export the grid to Excel instead.`,
        10,
      );
      return;
    }
    el.__printPending = true;
    el.__printCancelRequested = false;
    el.__printAbort = new AbortController();
    let unbindCancel = () => {};
    try {
      this._showPrintLoading(el);
      unbindCancel = this._enablePrintCancel(el);
      this._setPrintProgress(el, 3);
      this._setPrintLoadingDetail(el, 'Reading rows.');
      // Let the loading panel paint before the rows are read.
      await new Promise(resolve => setTimeout(resolve, 50));
      const header = this._collectPrintHeader(el);
      const table = await this._collectPrintTable(el, api, (done, total) => {
        this._throwIfPrintCancelled(el);
        this._setPrintProgress(el, (done / total) * 15);
      });
      this._throwIfPrintCancelled(el);
      // The SSR form layer reads posted lists as JSON text.
      const payload = { title: header.title, total_width: table.total_width };
      for (const [name, value] of Object.entries({ ...header, ...table })) {
        if (name !== 'title' && name !== 'total_width') payload[name] = JSON.stringify(value);
      }
      this._setPrintProgress(el, 15);
      this._setPrintLoadingDetail(el, 'Building your PDF pages.');
      const started = await this._printJobRequest(el.dataset.printJobUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: el.__printAbort.signal,
      });
      const jobId = (await started.json()).job_id;
      await this._waitForPrintJob(el, jobId);
      this._setPrintProgress(el, 97);
      this._setPrintLoadingDetail(el, 'Opening your preview.');
      const pdf = await this._printJobRequest(
        `${el.dataset.printPdfUrl}?job_id=${jobId}`,
        { method: 'GET', signal: el.__printAbort.signal });
      const filename = `${header.title.replace(/[^A-Za-z0-9]+/g, '_') || 'grid'}.pdf`;
      this._throwIfPrintCancelled(el);
      await this._showPdfPreview(el, await pdf.blob(), filename);
    } catch (error) {
      if (error.printCancelled || error.name === 'AbortError') {
        window.showFlashMessage(null, 'info', 'Grid Preview cancelled.', 5);
        return;
      }
      const fieldErrors = error.formErrors && Object.values(error.formErrors)[0];
      const message = fieldErrors?.[0]?.message;
      window.showFlashMessage(
        null,
        'error',
        message || 'Could not prepare the Grid Preview. Please try again.',
        10,
      );
      // A rejected preview is already explained; anything else must reach Bugsink.
      if (!error.formErrors) throw error;
    } finally {
      unbindCancel();
      delete el.__printAbort;
      delete el.__printCancelRequested;
      this._hidePrintLoading(el);
      delete el.__printPending;
    }
  },

  printGrid: async function (elOrId, waitMs = 300) {
    const el = this._resolveGridElement(elOrId);
    if (!el || el.__printPending) return;
    const api = window[`aggridApi:${el.dataset.agId}`];
    if (!api) return;
    if (this._shouldPrintOnServer(el, api)) {
      await this._printOnServer(el, api);
      return;
    }
    el.__printPending = true;
    const restoreLayout = () => {
      if (el.__printState) this.resetPrintLayout(el);
    };
    try {
      this._showPrintLoading(el);
      await new Promise(resolve => setTimeout(resolve, waitMs));
      this.setPrintLayout(el);
      api.refreshClientSideRowModel?.('filter');
      this._buildPrintTable(el);
      this._applyPrintMaxWidths(el);
      await this._printPreparedGrid(el, restoreLayout);
    } catch (error) {
      try {
        restoreLayout();
      } finally {
        this._hidePrintLoading(el);
        delete el.__printPending;
      }
      throw error;
    }
  }
};
